import { BasketClient } from '@frontend/basket/api';
import { Basket } from '@frontend/basket/types';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { useAppDispatch } from '../../redux/store';

export const useBasketUpdate = () => {
    const navigate = useNavigate();
    const { accountId, basketId } = useParams();
    const dispatch = useAppDispatch();
    const [basket, setBasket] = useState<Basket | null>(null);

    useEffect(() => {
        if (!accountId || !basketId) return;
        BasketClient.fetchBasket(accountId, basketId).then((basket) => {
            setBasket(basket);
        });
    }, [accountId, basketId]);

    const onCancel = () => {
        navigate(-1);
    };

    const onSubmitSuccess = (basket: Basket) => {
        navigate(`/accounts/${basket.account_id}/baskets/${basket.id}/detail`);
    };

    return {
        basket,
        onCancel,
        onSubmitSuccess,
        dispatch
    };
};
